// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'
import { RadioGroup } from 'components/Form'
import { useDispatch } from 'react-redux'
import RadioCode from './RadioCode'
import RadioManufacturer from './RadioManufacturer'
import handleRadioFieldToggle from './helpers/handleRadioFieldToggle'

const options = [{
  label: 'Code',
  value: 'radioCode',
}, {
  label: 'Manufacturer',
  value: 'radioCompanyId',
}]

const RadioField = props => {
  const {
    idRoot,
    input: { value },
    sourceForm,
  } = props

  const dispatch = useDispatch()

  const handleRadioFieldUpdate = event => dispatch(handleRadioFieldToggle(event, sourceForm))

  if (value !== 'radioCode' && value !== 'radioCompanyId') {
    throw new Error(`Error! Value was expected to be 'radioCode' or 'radioCompanyId' but was ${value}`)
  }

  return (
    <>
      <div className={'display-flex'}>
        <span>{'Radio'}</span>
        <RadioGroup
          {...props}
          className={'flat-radios mini-flat-radios'}
          idRoot={`${idRoot}-type`}
          onChangeCustom={handleRadioFieldUpdate}
          options={options} />
      </div>
      {
        value === 'radioCode'
          ? (
            <RadioCode
              idRoot={`${idRoot}-code`}
              sourceForm={sourceForm} />
          ) : (
            <RadioManufacturer
              idRoot={`${idRoot}-manufacturer`} />
          )
      }
    </>
  )
}

RadioField.propTypes = {
  idRoot: string.isRequired,
  input: object.isRequired,
  sourceForm: string.isRequired,
}
export default RadioField